import script from "./MediaCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaCard.vue?vue&type=script&setup=true&lang=js"

import "./MediaCard.vue?vue&type=style&index=0&id=70c6cc9e&lang=scss"

const __exports__ = script;

export default __exports__